import { toast } from "react-toastify"
import { FetchApi } from "../../../api/fetch"
import { ENDPOINT } from "../../../constants"
import { Notification } from "../../../components/Notification"
import { Blockchain, CollectionProps } from "./types"

export const submitDraftCollection = async ({
  collectionData,
  collectionProps,
}: any) => {

  const {
    name,
    description,
    candyMachineAddresses,
    website,
    twitter,
    discord,
    team,
    tiktok,
    instagram,
    medium,
    roadmap,
    atlas3,
    subber,
    twitch,
    isDerivative,
    isNsfw,
    links,
    youtube,
    creatorEmail,
    collectionKey,
    blockchain,
    slug,
  } = collectionData
  const {
    mintHashList,
    collectionThumbnail,
    collectionThumbnailUrl,
    setIsLoadingOverlayDisplay,
    collectionThumbnailName,
    collectionBannerName,
    collectionBanner,
    uploadFile,
    hasUploadMintList,
    thumbnailFile,
    bannerFile,
  } = collectionProps

  const special_tag_list = []
  isNsfw && special_tag_list.push("NSFW")
  isDerivative && special_tag_list.push("DERIVATIVE")

  if (!collectionThumbnail || collectionThumbnailUrl) {
    toast.error(
      <Notification
        title="Missing details"
        description="Please provide a collection thumbnail."
      />
    )
    return
  }

  setIsLoadingOverlayDisplay(true)
  try {
    if (hasUploadMintList) {
      // await uploadFile(
      //   mintFile,
      // )
    }

    await uploadFile(
      thumbnailFile,
    )

    if (collectionBanner) {
      await uploadFile(
        bannerFile,
      )
    }

    const urlBase = "https://creator-portal-bucket.s3.us-east-2.amazonaws.com"

    const userJWT = JSON.parse(sessionStorage.getItem('userData') || '{}').token

    const payload = {
      name: name,
      description: description,
      website: website?.length > 0 ? website : undefined,
      discord: discord?.length > 0 ? discord : undefined,
      twitter: twitter?.length > 0 ? twitter : undefined,
      medium: medium?.length > 0 ? medium : undefined,
      tiktok: tiktok?.length > 0 ? tiktok : undefined,
      team: team?.length > 0 ? team : undefined,
      roadmap: roadmap?.length > 0 ? roadmap : undefined,
      instagram: instagram?.length > 0 ? instagram : undefined,
      youtube: youtube?.length > 0 ? youtube : undefined,
      atlas3: atlas3?.length > 0 ? atlas3 : undefined,
      subber: subber?.length > 0 ? subber : undefined,
      twitch: twitch?.length > 0 ? twitch : undefined,
      slug: slug?.length > 0 ? slug : undefined,
      // mintListUrl: hasUploadMintList ? `${urlBase}/${mintHashListName}` : "",
      mints: mintHashList?.length > 0 ? mintHashList : undefined,
      wallet_address_list: candyMachineAddresses.length ? candyMachineAddresses : undefined,
      candyMachineAddresses:candyMachineAddresses.length ? candyMachineAddresses : undefined,
      collectionKey,
      thumbnailUrl: collectionThumbnail ?
        `${urlBase}/${collectionThumbnailName}`
        : "",
      bannerUrl: collectionBanner
        ? `${urlBase}/${collectionBannerName}`
        : "",
      special_tag_list: special_tag_list.length ? special_tag_list : undefined,
      specialTagList: special_tag_list.length ? special_tag_list : undefined,
      isNsfw,
      isDerivative,
      links: links,
      creatorEmail: creatorEmail?.length > 0 ? creatorEmail : undefined

    }
    const baseURL = blockchain !== Blockchain.Bitcoin ? ENDPOINT.CREATE_DRAFT_COLLECTION : ENDPOINT.CREATE_DRAFT_COLLECTION_ORDINAL
    const response = await FetchApi( {
      endpoint:baseURL,
      method: "POST",
      JWT:userJWT,
      body:  (payload)
    })

    return response
  } catch (error) {
    console.log(error)

  }
}

export const updateCollection = async (
  collectionData: any,
  collectionProps: CollectionProps
) => {
  const {
    name,
    description,
    candyMachineAddresses,
    website,
    twitter,
    discord,
    thumbnailUrl,
    bannerUrl,
    tiktok,
    instagram,
    medium,
    roadmap,
    atlas3,
    subber,
    twitch,
    isDerivative,
    isNsfw,
    links,
    creatorEmail,
    collectionKey,
    youtube,
    blockchain
  } = collectionData

  const {
    mintHashList,
    collectionThumbnail,
    setIsLoadingOverlayDisplay,
    collectionThumbnailName,
    collectionBannerName,
    collectionBanner,
    uploadFile,
    collectionStage,
    isReplaceMintList,
    collectionId,
    updateNameCheck,
    thumbnailFile,
    bannerFile,
  } = collectionProps


  const userJWT = JSON.parse(sessionStorage.getItem('userData') || '{}').token

  const special_tag_list = []
  isNsfw && special_tag_list.push("NSFW")
  isDerivative && special_tag_list.push("DERIVATIVE")


  if (!Boolean(updateNameCheck === name)) {
    toast.error(
      <Notification
        title="Updating names is not supported at this time."
        description="Unfortunately we do not support the updating of names at this current time."
      />
    )
    return
  }

  if (
    collectionStage === "live" &&
    mintHashList?.length > 0 &&
    isReplaceMintList === undefined
  ) {
    toast.error(
      <Notification
        title="Missing details"
        description="Please tell us what to do with your mint list."
      />
    )
    return
  }

  setIsLoadingOverlayDisplay(true)

  // if (mintHashList && mintFile) {
  //   await uploadFile(
  //     mintFile,
  //   )
  // }

  console.log(typeof (thumbnailFile), thumbnailFile);

  if (collectionThumbnail && thumbnailFile) {
    await uploadFile(
      thumbnailFile,
      collectionThumbnailName

    )
  }

  if (collectionBanner && bannerFile) {
    await uploadFile(
      bannerFile,
      collectionBannerName
    )
  }

  const urlBase = "https://creator-portal-bucket.s3.us-east-2.amazonaws.com"

  let payload = {
    name: name,
    description: description,
    website: website?.length > 0 ? website : undefined,
    discord: discord?.length > 0 ? discord : undefined,
    twitter: twitter?.length > 0 ? twitter : undefined,
    medium: medium?.length > 0 ? medium : undefined,
    tiktok: tiktok?.length > 0 ? tiktok : undefined,
    roadmap: roadmap?.length > 0 ? roadmap : undefined,
    instagram: instagram?.length > 0 ? instagram : undefined,
    youtube: youtube?.length > 0 ? youtube : undefined,
    atlas3: atlas3?.length > 0 ? atlas3 : undefined,
    subber: subber?.length > 0 ? subber : undefined,
    twitch: twitch?.length > 0 ? twitch : undefined,
    // mintListUrl: hasUploadMintList ? `${urlBase}/${mintHashListName}` : mintListUrl,
    mints: mintHashList?.length > 0 ? mintHashList : undefined,
    wallet_address_list: candyMachineAddresses,
    candyMachineAddresses,
    collectionKey,
    // thumbnail: collectionId ? collectionThumbnail : `${FIREBASE_STORAGE_BUCKET}/${currentUser?.uid}/draft/${uuid}/${collectionThumbnailName}`,
    thumbnailUrl: Boolean(thumbnailUrl && !collectionThumbnail) ? thumbnailUrl : `${urlBase}/${collectionThumbnailName}`,
    // banner_url: collectionId ? collectionBanner : `${FIREBASE_STORAGE_BUCKET}/${currentUser?.uid}/draft/${uuid}/${collectionBannerName}`,
    bannerUrl: Boolean(collectionBanner) ? `${urlBase}/${collectionBannerName}` : bannerUrl,
    special_tag_list: special_tag_list,
    specialTagList: special_tag_list,
    isNsfw,
    isDerivative,
    links: links,
    creatorEmail: creatorEmail?.length > 0 ? creatorEmail : undefined
    // replace_mint_list: isReplaceMintList
  }

  const baseURL = blockchain  !== Blockchain.Bitcoin ? ENDPOINT.UPDATE_DRAFT_COLLECTION : ENDPOINT.UPDATE_DRAFT_COLLECTION + '/ordinals'

  const response = await FetchApi( {
    endpoint:`${baseURL}/${collectionId}`,
    method: "PUT",
    JWT:userJWT,
    body:  (payload)
  })

  return response
}

export const publishDraftCollection = async ({
  collectionData,
  collectionProps,
}: any) => {

  const {
    name,
    description,
    candyMachineAddresses,
    website,
    twitter,
    discord,
    team,
    tiktok,
    instagram,
    medium,
    roadmap,
    isDerivative,
    isNsfw,
    links,
    youtube,
    atlas3,
    subber,
    twitch,
    collectionKey,
    bannerUrl,
    thumbnailUrl,
    creatorEmail,
    blockchain,
  } = collectionData
  const {
    mintHashList,
    collectionThumbnail,
    setIsLoadingOverlayDisplay,
    collectionThumbnailName,
    collectionBannerName,
    uploadFile,
    collectionBanner,
    collectionId,
    thumbnailFile,
    bannerFile,
  } = collectionProps

  const special_tag_list = []
  isNsfw && special_tag_list.push("NSFW")
  isDerivative && special_tag_list.push("DERIVATIVE")


  setIsLoadingOverlayDisplay(true)
  try {
    // if (mintHashList && mintFile) {
    //   await uploadFile(
    //     mintFile,
    //   )
    // }

    if (collectionThumbnail && thumbnailFile) {
      await uploadFile(
        thumbnailFile,
      )
    }

    if (collectionBanner && bannerFile) {
      await uploadFile(
        bannerFile,
      )
    }


    const userJWT = JSON.parse(sessionStorage.getItem('userData') || '{}').token

    const urlBase = "https://creator-portal-bucket.s3.us-east-2.amazonaws.com"

    let payload = {
      name: name,
      description: description,
      website: website?.length > 0 ? website : undefined,
      discord: discord?.length > 0 ? discord : undefined,
      twitter: twitter?.length > 0 ? twitter : undefined,
      medium: medium?.length > 0 ? medium : undefined,
      tiktok: tiktok?.length > 0 ? tiktok : undefined,
      team: team?.length > 0 ? team : undefined,
      roadmap: roadmap?.length > 0 ? roadmap : undefined,
      instagram: instagram?.length > 0 ? instagram : undefined,
      youtube: youtube?.length > 0 ? youtube : undefined,
      atlas3: atlas3?.length > 0 ? atlas3 : undefined,
      subber: subber?.length > 0 ? subber : undefined,
      twitch: twitch?.length > 0 ? twitch : undefined,
      // mintListUrl: hasUploadMintList ? `${urlBase}/${mintHashListName}` : mintListUrl,
      mints: mintHashList?.length > 0 ? mintHashList : undefined,
      // wallet_address_list: candyMachineAddresses,
      candyMachineAddresses,
      collectionKey,
      thumbnailUrl: Boolean(thumbnailUrl && !collectionThumbnail) ? thumbnailUrl : `${urlBase}/${collectionThumbnailName}`,
      bannerUrl: Boolean(collectionBanner) ? `${urlBase}/${collectionBannerName}` : bannerUrl,
      // special_tag_list: special_tag_list,
      specialTagList: special_tag_list,
      isNsfw,
      isDerivative,
      links: links,
      creatorEmail: creatorEmail?.length > 0 ? creatorEmail : undefined
    }

    const baseURL = blockchain !== Blockchain.Bitcoin ? ENDPOINT.SUBMIT : ENDPOINT.SUBMIT + '/ordinals'

    const response = await FetchApi({
      endpoint:`${baseURL}/${collectionId}/submit_listing`, 
      method: "POST",
      JWT:userJWT,
      body:  (payload)
    })

    return response

  } catch (error) {
    console.log(error)
  }
}
